<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter
                        :headers="headers"
                        :viewName="viewName"
                        v-on:applyFilter="applyFilter"
                        v-on:quickFilter="quickFilter"
                    ></hpo-filter>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :options.sync="pagination"
                        :server-items-length="totalRows"
                        :footer-props="itemsPerPage"
                        :loading="loading"
                        :mobile-breakpoint="100"
                        fixed-header
                        height="calc(100vh - 300px)"
                    >
                        <template v-slot:item.Status="{ item }">
                            <v-chip small dark :color="getStatusColor(item.Status)">
                                {{ item.Status | display_value(statusList) }}
                            </v-chip>
                        </template>
                        <template v-slot:item.CreatedDate="{ item }">
                            {{ item.CreatedDate | display_date }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <div class="text-center">
                                <table-action-buttons :actions="getItemActions(item)" :stacked="false"></table-action-buttons>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import configs from '@/configs';
import Filtering from '@/components/Filtering';

export default {
    components: {
        'hpo-filter': Filtering
    },
    data() {
        return {
            viewName: 'export_request_list',
            pagination: { ...configs.PAGINATION },
            itemsPerPage: { ...configs.ITEMS_PER_PAGE },
            filterConditions: [],
            quickFilterConditions: [],
            statusList: configs.EXPORT_REQUEST_STATUS_LIST,
        };
    },
    computed: {
        ...mapState({
            items: state => state.exportRequest.all.data,
            totalRows: state => state.exportRequest.all.total,
            loading: state => state.exportRequest.loading,
        }),
        roleCustomer() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
        },
        headers() {
            const headers = [
                {
                    text: 'Mã yêu cầu',
                    value: 'RequestCode',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String,
                },
                {
                    text: 'Khách hàng tạo yêu cầu',
                    value: 'Username',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String,
                },
                {
                    text: 'Tên khách hàng',
                    value: 'CustomerName',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String,
                },
                {
                    text: 'Loại hàng',
                    value: 'GoodsTypes',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String,
                },
                {
                    text: 'Mã vận đơn',
                    value: 'SuffixBills',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String,
                },
            ];

            headers.push(
                {
                    text: 'Số dòng',
                    value: 'TotalProduct',
                    align: 'end',
                    filterable: true,
                    dataType: configs.DATA_TYPE.Number,
                },
                {
                    text: 'Tổng kiện yêu cầu',
                    value: 'TotalPack',
                    align: 'end',
                    filterable: true,
                    dataType: configs.DATA_TYPE.Number,
                },
                {
                    text: 'Phiếu xuất liên kết',
                    value: 'BillCode',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String,
                },
                {
                    text: 'Trạng thái',
                    value: 'Status',
                    filterable: true,
                    values: this.statusList,
                    dataType: configs.DATA_TYPE.Enum,
                },
                {
                    text: 'Ngày tạo',
                    value: 'CreatedDate',
                    filterable: true,
                    dataType: configs.DATA_TYPE.Date,
                },
                {
                    text: 'Ghi chú',
                    value: 'Note',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE.String,
                },
                {
                    text: 'Thao tác',
                    value: 'actions',
                    sortable: false,
                    filterable: false,
                    align: 'center',
                    width: '100px',
                }
            );
            return headers;
        }
    },
    watch: {
        pagination: {
            handler() {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : [];
                this.loadData();
            },
            deep: true
        }
    },
    methods: {
        getItemActions(item) {
            return [
                { label: this.$t('actions.view'), variant: 'primary', onClick: () => this.openItem(item.ID) }
            ];
        },
        getStatusColor(status) {
            const item = this.statusList.find(entry => entry.value == status);
            return item ? item.color : 'grey';
        },
        loadData() {
            this.$store.dispatch('exportRequest/getList', {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions,
            });
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy;
            let sortDesc = this.pagination.sortDesc;
            this.pagination = { ...configs.PAGINATION };
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.loadData();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.loadData();
        },
        openItem(id) {
            this.$router.push({
                name: 'ExportRequestDetail',
                params: {
                    Pid: id || 'new'
                }
            });
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {
            invisibleCreateButton: !this.roleCustomer
        });
        this.$root.$on('REQUEST_CREATE_DATA', () => this.openItem(0));
        this.$root.$on('REQUEST_REFRESH_DATA', this.loadData);
        this.loadData();
    },
    beforeDestroy() {
        this.$root.$off('REQUEST_CREATE_DATA');
        this.$root.$off('REQUEST_REFRESH_DATA');
    }
};
</script>
